import $ from 'jquery'

if ($('#comments').length > 0) {
	var $form     = $('#comment-form');
	var $title    = $form.find('.title');
	var def_title = $title.html();

	$('.comment a.reply').click(function (e) {
		e.preventDefault();
		var $this  = $(this);
		var active = $this.data('active');

		var $li = $this.closest('.comment');
		var id  = $li.data('id')

		if (active === id) {
			$li.find('.close').trigger('click');
			return;
		}
		$this.data('active', id);

		var $close = $('<button title="Annulla risposta" type="button" class="close pull-right" aria-hidden="true">&times;</button>');
		$title.text($title.data('answer') + ' ' + $li.find('.title strong').text()).append($close);
		$form.insertAfter($li.find('.comment-content:first'));
		$form.find('input.parent').val($li.data('id'));

		$close.click(function (e) {
			e.preventDefault();
			$title.html(def_title);
			$form.appendTo('.comments-block');
			$form.find('input.parent').val(0);
			$(this).remove();
		});
	});

	var $button    = $form.find('input[type=submit]').prop('disabled', false);
	var submitText = $button.data('submit');
	var normalText = $button.val();

	var $response       = $form.find('.contact_response');
	var $response_title = $response.find('h2');
	var $response_msg   = $response.find('p');

	$button.data('original', $button.html());

	$form.submit(function (e) {
		$response.addClass('u-hidden').removeClass('Alert--success Alert--danger');
		$button.val(submitText).prop('disabled', true);
		e.preventDefault();

		var data  = $form.serializeObject();
		data.ajax = 1;
		$.ajax({
			type    : 'POST',
			url     : $form.attr('action'),
			data    : data,
			success : function (response) {
				// H = response.H;

				var formTop = $form.offset().top;
				var status  = response.msgStatus;
				var msg     = response.message;
				var title   = response.title;

				if (status === "ok") {
					$response.addClass('Alert--success');
					$response_title.html(title);
					$response_msg.html(msg);
					$form.find("textarea").val("");
					$form.find('button.close').trigger('click');
				} else if (status === "error") {
					$response_title.html(title);
					$response.addClass('Alert--danger');
					if (response.errorFields.length) {
						for (var i = 0; i < response.errorFields.length; i++) {
							$form.find("#" + response.errorFields[i]).addClass("error");
						}
						$response_msg.html(response.errors_html);
					} else $response_msg.html(msg);
				} else {
					$response.addClass('Alert--danger');
					$response_title.text('Errore!');
					$response_msg.text('Errore generico, riprova più tardi.');
				}

				$response.removeClass('u-hidden');
				$button.val(normalText).prop('disabled', false);
				window.scrollTo(0, formTop);

			}
		});

	});
}

$.fn.serializeObject = function () {
	var o = {};
	var a = this.serializeArray();
	$.each(a, function () {
		if (o[this.name] !== undefined) {
			if (!o[this.name].push) {
				o[this.name] = [o[this.name]];
			}
			o[this.name].push(this.value || '');
		} else {
			o[this.name] = this.value || '';
		}
	});
	// o[N] = H;
	return o;
};



// WEBPACK FOOTER //
// ./src/themes/pac/js/comments.js